import React from "react";
import ReactPlaceholder from "react-placeholder";
import "react-placeholder/lib/reactPlaceholder.css";

const ReactPlaceholderLoader = (props) => {
  const { type, rows, ready } = props;
  return (
    <div>
      <ReactPlaceholder
        type={type}
        rows={rows}
        ready={ready}
      ></ReactPlaceholder>
    </div>
  );
};

export default ReactPlaceholderLoader;
